import React from "react";
import { Box, Card, CardContent, Typography, Grow } from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import {
  LocalFireDepartment,
  TrendingUp,
  TrendingDown,
  BarChart,
} from "@mui/icons-material";
import { formatCurrency } from "../../../utils/price";

const HighlightCards = ({ currentCountryData, currencySymbols }) => {
  const theme = useTheme();
  const highlights = currentCountryData.highlights || {};
  // console.log("Highlight data:", currentCountryData.highlights);

  // Calculate dynamic highlight cards based on current country data
  // const getHighlightCards = () => {
  //   if (!highlightCardsData || highlightCardsData.length === 0) return [];

  //   // Find top gainer
  //   const topGainer = highlightCardsData.reduce((prev, curr) => {
  //     const prevChange = parseFloat(prev.change_24h) || 0;
  //     const currChange = parseFloat(curr.change_24h) || 0;
  //     return currChange > prevChange ? curr : prev;
  //   });

  //   // Find top loser
  //   const topLoser = highlightCardsData.reduce((prev, curr) => {
  //     const prevChange = parseFloat(prev.change_24h) || 0;
  //     const currChange = parseFloat(curr.change_24h) || 0;
  //     return currChange < prevChange ? curr : prev;
  //   });

  //   // Find highest volume
  //   const highVolume = highlightCardsData.reduce((prev, curr) => {
  //     const prevVolume = parseFloat(prev.volume) || 0;
  //     const currVolume = parseFloat(curr.volume) || 0;
  //     return currVolume > prevVolume ? curr : prev;
  //   });

  //   // Hot scrap (highest price)
  //   const hotScrap = highlightCardsData.reduce((prev, curr) => {
  //     return curr.price_per_kg > prev.price_per_kg ? curr : prev;
  //   });

  //   const getSymbol = (item) => currencySymbols[item.currency] || item.currency || "$";

  //   return
  // };

  const getSymbol = (item) =>
    currencySymbols?.[item?.currency] || item?.currency || "A$";
  //   console.log("API formatted_price:", highlights?.hot_scrap?.formatted_price)
  // console.log("API raw price:", highlights?.hot_scrap?.price)

  const highlightCards = [
    {
      label: "Hot Scrap",
      value: `${highlights?.hot_scrap?.material || "-"} 
      
      ${highlights?.hot_scrap?.formatted_price || 0}`,
      // ${parseFloat().toFixed(2)}
      //${getSymbol(highlights?.hot_scrap)} 
      // value: `${highlights?.hot_scrap?.material || "-"} ${formatCurrency(highlights.hot_scrap.formatted_price)}`,
      color: theme.palette.warning.main,
      bgColor: alpha(theme.palette.warning.main, 0.1),
      icon: (
        <LocalFireDepartment
          sx={{ fontSize: 28, color: theme.palette.warning.main }}
        />
      ),
      description: "Most active material",
    },

    {
      label: "Top Gainer",
      value: `${highlights?.top_gainer?.material || "-"} ${highlights?.top_gainer?.change_percent || "-"
        }`,
      color: theme.palette.success.main,
      bgColor: alpha(theme.palette.success.main, 0.1),
      icon: (
        <TrendingUp sx={{ fontSize: 28, color: theme.palette.success.main }} />
      ),
      description: "Highest price increase",
    },
    {
      label: "Top Loser",
      value: `${highlights?.top_loser?.material || "-"} ${highlights?.top_loser?.change_percent || "-"
        }`,
      color: theme.palette.error.main,
      bgColor: alpha(theme.palette.error.main, 0.1),
      icon: (
        <TrendingDown sx={{ fontSize: 28, color: theme.palette.error.main }} />
      ),
      description: "Highest price decrease",
    },
    {
      label: "High Volume",
      value: `${highlights?.high_volume?.material || "-"} ${highlights?.high_volume?.formatted_volume || "-"
        }`,
      color: theme.palette.info.main,
      bgColor: alpha(theme.palette.info.main, 0.1),
      icon: <BarChart sx={{ fontSize: 28, color: theme.palette.info.main }} />,
      description: "Most traded volume",
    },
  ];

  return (
    <Box sx={{ mb: 4 }}>
      <Box
        sx={{
          display: "flex",
          gap: 3,
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        {highlightCards.map((item, i) => (
          <Box
            key={i}
            sx={{
              flex: {
                xs: "1 1 100%",
                sm: "1 1 calc(50% - 12px)",
                lg: "1 1 calc(25% - 18px)",
              },
            }}
          >
            <Grow in timeout={1200 + i * 200}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: 4,
                  boxShadow: theme.shadows[8],
                  border: `2px solid ${alpha(item.color, 0.2)}`,
                  background: `linear-gradient(135deg, ${item.bgColor
                    } 0%, ${alpha(item.color, 0.05)} 100%)`,
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: theme.shadows[16],
                    border: `2px solid ${alpha(item.color, 0.4)}`,
                  },
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      fontWeight="medium"
                    >
                      {item.label}
                    </Typography>
                    {item.icon}
                  </Box>
                  <Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
                    {item.value}
                  </Typography>
                  {/* <Typography variant="body2" color="text.secondary">
                    {item.description}
                  </Typography> */}
                </CardContent>
              </Card>
            </Grow>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default HighlightCards;
